import TrackItDimensionModel from 'src/types/track-it-dimension.model';

export default class TrackItService {
    public static appendTrackItScript(): void {
        const hasScript: boolean = document.getElementById('track-it-script') != null;
        if (hasScript) return; // return if script already exists

        const srcLoc: string = process.env.REACT_APP_TRACK_IT_SRC;
        if (!srcLoc) return; // return if env var is not set

        const script = document.createElement('script');
        script.src = srcLoc;
        script.async = true;
        script.id = 'track-it-script';
        script.type = 'text/javascript';
        script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
    }

    public static trackExperiment(id: string, name: string, dimensions: TrackItDimensionModel[]): void {
        if (!window?.trackIt) {
            console.log('no window.trackIt');
            return;
        } // return if TrackIt is not loaded or if window object is unavailable
        window.trackIt.trackExperiment({
            id,
            name,
            dimensions: dimensions || [],
            source: 'ONE XP'
        });
    }
}
